"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.get = function get(sessionId, id, success, error) {
  if (sessionId) {
    agendorAPI.sessionId = sessionId;
  }
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.get("/deals/" + id, null, responseHandler);
};

module.exports.update = function update(id, params, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.put(`/deals/${id}`, params, responseHandler);
};

module.exports.partialUpdate = function partialUpdate(id, params, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.patch(`/deals/${id}`, params, responseHandler);
};

module.exports.statusUpdate = function statusUpdate(id, params, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.patch(`/deals/${id}/status`, params, responseHandler);
}



// WEBPACK FOOTER //
// ./app/util/api/deals.js